:host {
  display: flex;
  align-items: center;
  padding: var(--spacing-l, $spacing-l) var(--spacing-l, $spacing-l) var(--spacing-s, $spacing-s);
  background-color: var(--background-color-primary, background-color('primary'));

  @media (--md-min) {
    display: none;
  }
}

.spacer {
  display: block;
  width: pxToRem(36);
  height: pxToRem(36);
}

.corner-section {
  display: flex;
  gap: var(--spacing-xs, $spacing-xs);

  &.start {
    display: flex;
    justify-content: flex-start;
  }

  &.center {
    display: flex;
    flex: 1;
    justify-content: center;
  }

  &.end {
    display: flex;
    justify-content: flex-end;
  }
}
